export default __webpack_public_path__ + "static/media/design-6.5d76c2f5.png";